import { Icon, ICONS } from '@bob/library'
import clsx from 'clsx'
import { alert, AlertVariant, styles } from 'leds'
import React, { ComponentPropsWithoutRef, FC } from 'react'

export type AlertProps = AlertVariant & ComponentPropsWithoutRef<'div'>

export const Alert: FC<AlertProps> = ({ type, highlight, children, ...divProps }) => (
  <div
    {...divProps}
    className={clsx(alert({ type, highlight, withPadding: true }), divProps?.className)}
    role={'alert'}
  >
    <Icon icon={ICONS.WARNING} />
    <span className={styles({ paddingLeft: 16 })}>{children}</span>
  </div>
)
